import { render, staticRenderFns } from "./slinfo.vue?vue&type=template&id=46b68ca0&scoped=true"
import script from "./slinfo.vue?vue&type=script&lang=js"
export * from "./slinfo.vue?vue&type=script&lang=js"
import style0 from "./slinfo.vue?vue&type=style&index=0&id=46b68ca0&prod&lang=less"
import style1 from "./slinfo.vue?vue&type=style&index=1&id=46b68ca0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b68ca0",
  null
  
)

export default component.exports